<app-modal-filler-atom [index]="(index$ | async) ?? 0"></app-modal-filler-atom>
<div
  class="fixed left-0 right-0 overflow-y-auto shadow md:left-0 md:top-0 md:flex md:h-full md:w-full md:items-center md:justify-center mdMax:bottom-0 mdMax:mx-auto mdMax:max-h-85-screen mdMax:max-w-screen-sm"
  [style.z-index]="((index$ | async) ?? 0) + 50"
>
  <app-modal-filler-atom
    [withBackdrop]="false"
    [index]="(index$ | async) ?? 0"
    *ngIf="settingsSelector.selectDeviceIsDesktopScreen | async"
  ></app-modal-filler-atom>
  <div
    class="rounded-t-3xl bg-white p-5 md:max-w-lg md:rounded-3xl md:p-7"
    [style.z-index]="((index$ | async) ?? 0) + 50"
  >
    <div *ngIf="!user?.[userKeys.Id] || !user?.[userKeys.Email]">
      <app-authentication-block
        [userJourneyType]="userJourneyType"
        [legalCheckboxLabel]="legalCheckboxLabel"
        [optinCheckboxLabel]="optinCheckboxLabel"
        [firstStepHeading]="firstStepHeading"
        [firstStepLoginButton]="firstStepLoginButton"
        [firstStepSignupButton]="firstStepSignupButton"
        [loginStepHeading]="loginStepHeading"
        [signupStepHeading]="signupStepHeading"
        [signupStepSubheading]="signupStepSubheading"
        [signupStepDisplayFirstname]="signupStepDisplayFirstname"
        [signupStepFirstnameLabel]="signupStepFirstnameLabel"
        [signupStepFirstnameHelp]="signupStepFirstnameHelp"
        [signupStepDisplayLastname]="signupStepDisplayLastname"
        [signupStepLastnameLabel]="signupStepLastnameLabel"
        [signupStepLastnameHelp]="signupStepLastnameHelp"
        [signupStepEmailLabel]="signupStepEmailLabel"
        [signupStepEmailHelp]="signupStepEmailHelp"
        [signupStepDisplayPhone]="signupStepDisplayPhone"
        [signupStepPhoneLabel]="signupStepPhoneLabel"
        [signupStepPhoneHelp]="signupStepPhoneHelp"
        [signupStepPasswordLabel]="signupStepPasswordLabel"
        [signupStepPasswordHelp]="signupStepPasswordHelp"
        [signupFooter]="signupFooter"
        [authenticationProviderGoogle]="authenticationProviderGoogle"
        [authenticationProviderFacebook]="authenticationProviderFacebook"
        [authenticationProviderApple]="authenticationProviderApple"
        [cgvUrl]="cgvUrl"
      ></app-authentication-block>
    </div>
    <div *ngIf="user?.[userKeys.Id] && user?.[userKeys.Email]">
      <p class="mb-7 mt-5 font-base text-neutral-600">
        {{ 'authentication.already-logged-in.already-logged-in-as-user' | translate: user }}
      </p>
      <div class="flex items-center justify-between pt-1">
        <div class="mr-2 w-full xm:w-1/2 xm:pr-1">
          <app-button-atom
            size="M"
            [label]="'authentication.already-logged-in.cancel-button' | translate"
            color="primary"
            (click)="close()"
            type="light"
            [full]="true"
          ></app-button-atom>
        </div>
        <div class="w-full xm:w-1/2 xm:pl-1">
          <app-button-atom
            size="M"
            [label]="'authentication.already-logged-in.logout-button' | translate"
            (click)="logout()"
            type="primary"
            [full]="true"
          ></app-button-atom>
        </div>
      </div>
    </div>
  </div>
</div>
